<template>
  <svg
    id="Menu-More-Horizontal--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <desc>Menu More Horizontal Streamline Icon: https://streamlinehq.com</desc>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M3.5 8.5C1.567 8.5 0 10.067 0 12s1.567 3.5 3.5 3.5S7 13.933 7 12 5.433 8.5 3.5 8.5Zm8.5 0c-1.933 0 -3.5 1.567 -3.5 3.5s1.567 3.5 3.5 3.5 3.5 -1.567 3.5 -3.5 -1.567 -3.5 -3.5 -3.5Zm8.5 0c-1.933 0 -3.5 1.567 -3.5 3.5s1.567 3.5 3.5 3.5S24 13.933 24 12s-1.567 -3.5 -3.5 -3.5Z"
      clip-rule="evenodd"
      stroke-width="1"
    ></path>
  </svg>
</template>
